import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    VStack,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    formInputStyles,
} from 'components/forms/new/formStyles';
import NameField from '@/components/forms/new/formikFormFields/NameField';

const RuleNameField = ({ darkMode, errors, touched, ...props }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            isInvalid={!!errors.name && touched.name}
            sx={{ margin: '0 !important' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            isRequired>
            <Stack
                direction="row"
                sx={{ ...stackStyling(), ...formInputStyles }}>
                <Box w="200px">
                    <FormLabel sx={formLabelStyling(darkMode)}>Name</FormLabel>
                </Box>
                <Box flex="1" minWidth="450px">
                    <VStack width="100%" alignItems="normal">
                        <Field
                            component={NameField}
                            id="name"
                            name="name"
                            placeholder="Enter rule name"
                            validate={(value) =>
                                !value && 'Rule Name is required'
                            }
                            {...props}
                        />
                        <FormErrorMessage>{errors.name}</FormErrorMessage>
                    </VStack>
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Enter a descriptive name for this rule. We recommend a standard naming convention like 'CountryCode-Standard/CallCategory' (e.g., AR-Standard/International) for easy sorting."
                        ariaLabel="rule name tooltip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default RuleNameField;
